import { AboutDialog } from '@theia/core/lib/browser/about-dialog';
import { ContainerModule, interfaces } from 'inversify';
import { MBAboutDialog } from './mb-about-dialog';

export function bindMBAboutDialogContribution(bind: interfaces.Bind, unbind: interfaces.Unbind, isBound: interfaces.IsBound, rebind: interfaces.Rebind) {
    isBound(AboutDialog) ? rebind(AboutDialog).to(MBAboutDialog).inSingletonScope() : bind(AboutDialog).to(MBAboutDialog).inSingletonScope();
}

export default new ContainerModule(bindMBAboutDialogContribution);